
<div fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="30px">
   
    <div class="form-container" ngClass.lt-md="form-container-mobile">
        <p fxLayoutAlign="space-around center"><strong>{{'rTitle' | translate}}</strong></p>
        <form fxLayout="row wrap" #requestForm="ngForm" fxLayoutAlign="space-around center">
            <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill">
                <mat-label>{{'firstName' | translate}}</mat-label>
                <input required [(ngModel)]="information.contactFirstName" name="firstname" matInput>
            </mat-form-field>

            <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill">
                <mat-label>{{'lastName' | translate}}</mat-label>
                <input required [(ngModel)]="information.contactLastName" name="lastname" matInput>
            </mat-form-field>

            <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill">
                <mat-label>{{'Company' | translate}}</mat-label>
                <input required [(ngModel)]="information.companyName" name="companyName" matInput>
            </mat-form-field>

            <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill">
                <mat-label>{{'email' | translate}}</mat-label>
                <input type="email" required [(ngModel)]="information.contactEmail" name="email" matInput #email="ngModel" 
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,256}$">
            </mat-form-field>

            <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill">
                <mat-label>{{'phone' | translate}}</mat-label>
                <input required [(ngModel)]="information.contactPhone1" name="phone" matInput>
            </mat-form-field>

            <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill">
                <mat-label>{{'contactLanguage' | translate}}</mat-label>
                <mat-select required [(ngModel)]="information.contactLanguage" name="language" [(value)]="request.contactLanguage">
                  <mat-option *ngFor="let language of languages" [value]="language">
                    {{language}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            <p fxFlex="60" fxFlex.lt-md="100" appearance="fill">{{'pSubTitle' | translate}}</p>
            <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill">
                <mat-label>{{'adress' | translate}}</mat-label>
                <input required [(ngModel)]="information.contactAddress1" name="address1" matInput>
            </mat-form-field>

            <div fxFlex="60" fxFlex.lt-md="100" class="form-row" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                <mat-form-field appearance="fill" fxFlex="20" fxFlex.lt-sm="100">
                    <mat-label>{{'zip' | translate}}</mat-label>
                    <input required [(ngModel)]="information.contactZip" name="zip" matInput>
                </mat-form-field>

                <mat-form-field appearance="fill" fxFlex="75" fxFlex.lt-sm="100">
                    <mat-label>{{'city' | translate}}</mat-label>
                    <input required [(ngModel)]="information.contactCity" name="city" matInput>
                </mat-form-field>
            </div>
            

            <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill">
                <mat-label>{{'country' | translate}}</mat-label>
                <mat-select required [(ngModel)]="information.contactCountry" name="country" [(value)]="selected">
                  <mat-option *ngFor="let country of countries" [value]="country">
                    {{country}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              

              <div  *ngIf="stolen" fxFlex="60" fxFlex.lt-md="100" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap.lg="10px">
                <mat-form-field appearance="fill" fxFlex="75" fxFlex.lt-sm="100">
                    <mat-label>{{'pv' | translate}}</mat-label>
                    <input required [(ngModel)]="request.pvNumber" name="pvNumber" matInput>
                </mat-form-field>
                <div class="file-input p-1" fxFlex="20" fxFlex.lt-sm="100" fxLayoutAlign="center center">
                    <input required type="file" accept="image/png, image/jpeg, application/pdf" multiple="true" style="display: none;" id="fileInput" (change)="fileChange($event)">
                    <button *ngIf="!request.attachments[0]" (click)="selectFile()" mat-raised-button>{{'uploadFile' | translate}}</button>
                    <button color="primary" *ngIf="request.attachments[0]" mat-raised-button>{{request.attachments[0].path}}</button>
                </div>
            </div>

            <div *ngIf="inquiry" fxLayout="row wrap" fxFlex="60" fxFlex.lt-md="100" fxLayoutAlign="space-around center" fxLayoutGap.lg="10px">
                <mat-form-field appearance="fill" fxFlex="75" fxFlex.lt-sm="100">
                    <mat-label>{{'invoice' | translate}}</mat-label>
                    <input required [(ngModel)]="request.pvNumber" name="pvNumber" matInput>
                </mat-form-field>
                <div class="file-input" fxFlex="20" fxFlex.lt-sm="100" fxLayoutAlign="center center">
                    <input required type="file" accept="image/png, image/jpeg, application/pdf" multiple="true" style="display: none;" id="fileInput" (change)="fileChange($event)">
                    <button *ngIf="!request.attachments[0]" (click)="selectFile()" mat-raised-button>{{'uploadFile' | translate}}</button>
                    <button color="primary" *ngIf="request.attachments[0]" mat-raised-button>{{request.attachments[0].path}}</button>
                </div>
            </div>
             

              <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill">
                <mat-label>{{'additional' | translate}}</mat-label>
                <textarea  [(ngModel)]="request.contactAdditionalInfo" name="additionalinfo" matInput rows="5"></textarea>
              </mat-form-field>
          
              <div class="p-1" fxFlex="100" fxLayoutAlign="space-evenly center">
                  <button mat-raised-button color="primary" (click)="back()"><mat-icon>arrow_back</mat-icon></button>
                  <button mat-raised-button color="primary" [routerLink]="['/home']"><mat-icon >home</mat-icon></button>
                <button mat-raised-button color="primary" [disabled]="!requestForm.form.valid" (click)="onSubmit()"><mat-icon>arrow_forward</mat-icon></button>
              </div>
             
        </form>
    </div>

</div>
